import styled from '@emotion/styled'

export const Container = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-rows: 40px calc(100% - 40px);
  grid-template-columns: 100%;
`

export const Top = styled.div`
  display: flex;
  align-content: flex-end;
  justify-content: flex-end;
  width: 100%;
`

export const Middle = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const ButtonExitStartScreen = styled.button`
  margin-top: 145px;
  background: none;
  border: none;
  cursor: pointer;
  opacity: 0.4;
`

export const ButtonFilters = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`
